import { render, staticRenderFns } from "./courseofflineDetail.vue?vue&type=template&id=79ad1742&scoped=true&"
import script from "./courseofflineDetail.vue?vue&type=script&lang=js&"
export * from "./courseofflineDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseofflineDetail.vue?vue&type=style&index=0&id=79ad1742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad1742",
  null
  
)

export default component.exports